import React from 'react';
import { useNavigate } from 'react-router-dom';

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center max-w-lg px-8">
        {/* App Name */}
        <h1 className="text-7xl font-bold text-gray-900 mb-4 tracking-tight">
          CineSense
        </h1>
        
        {/* Brief Description */}
        <p className="text-lg text-gray-600 leading-relaxed mb-12">
          Discover your next favorite movie with AI-powered recommendations tailored to your taste.
        </p>

        {/* Buttons */}
        <div className="flex gap-4 justify-center">
          <button 
            onClick={() => navigate('/login')} 
            className="px-10 py-3.5 text-base font-semibold text-white bg-gray-900 rounded-lg shadow-md hover:bg-gray-800 transition-all duration-200"
          >
            Login
          </button>
          
          <button 
            onClick={() => navigate('/signup')} 
            className="px-10 py-3.5 text-base font-semibold text-gray-900 bg-white border-2 border-gray-900 rounded-lg shadow-md hover:bg-gray-50 transition-all duration-200"
          >
            Register
          </button>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
